import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const LectureTranscription: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Free Lecture Transcription App - AI Audio to Text | YouWo AI"
      metaDescription="Transcribe lectures automatically with AI. Record in class or upload audio files. Get accurate transcriptions with speaker detection and study notes. Free for students."
      keywords="lecture transcription, transcribe lecture, lecture to text, class transcription app, record lecture, speech to text lecture, audio to text"
      canonicalUrl="https://youwo.ai/tools/lecture-transcription"
      // Hero
      headline="Free Lecture Transcription with AI"
      subheadline="Never miss a word from class again. Record lectures and get accurate transcriptions with key concepts highlighted and study notes generated automatically."
      heroIcon="lucide:audio-lines"
      heroIconColor="text-cyan-500"
      heroIconBg="bg-cyan-50"
      // Problem/Solution
      problemTitle="Taking Notes and Listening is Hard"
      problemDescription="When you're writing, you're not listening. When you're listening, you're not writing. It's impossible to capture everything while staying engaged with the lecture."
      solutionTitle="AI Captures Everything"
      solutionDescription="Just hit record and focus on understanding. Our AI transcribes every word, identifies speakers, and highlights key concepts. You'll have complete notes without missing a thing."
      // Features
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Transcribe lectures in over 100 languages with automatic detection.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Click any part of the transcript to jump to that moment in the recording.",
        },
        {
          icon: "lucide:mic",
          title: "One-Tap Recording",
          description: "Start recording instantly in class. Works offline and syncs when connected.",
        },
        {
          icon: "lucide:users",
          title: "Speaker Detection",
          description: "AI identifies different speakers so you know who said what.",
        },
        {
          icon: "lucide:layers",
          title: "Active Recall Flashcards",
          description: "Generate flashcards using active recall from your transcripts.",
        },
        {
          icon: "lucide:search",
          title: "Searchable Archive",
          description: "Search across all your lectures to find any topic instantly.",
        },
      ]}
      // CTA
      ctaText="Start Recording Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
        { name: "Audio Transcriber", href: "/tools/audio-transcriber", icon: "lucide:mic" },
        { name: "Otter.ai Alternative", href: "/tools/otter-ai-alternative", icon: "lucide:mic" },
        { name: "Meeting Notes", href: "/tools/meeting-notes", icon: "lucide:users" },
      ]}
    />
  );
};

export default LectureTranscription;
